<template>

    <div class="segment">
      <div class="columns">
        <div class="column">
          <div class="control">
            <div class="select">
              <select disabled>
                <option>2021 / 2022</option>
              </select>
            </div>
          </div>
          <div class="control">
            <div class="select">
              <select disabled>
                <option>EHIL & Challenge Cup</option>
              </select>
            </div>
          </div>
          <small>All Situations - Unless specified</small>
        </div>
        <div class="column is-offset-1">
          <figure class="image is-128x128">
            <img src="https://devils.roblutken.com/devils/assets/player-pictures/Cardiff_Devils.png" alt="" class="is-rounded">
          </figure>
        </div>
        <div class="column">
          <h1 class="title is-uppercase">{{PlayerData.player.name}}</h1>
          <div class="columns">
            <div class="column">
              <h2 class="subtitle">Position: {{PlayerData.player.position}}</h2>
            </div>
            <div class="column">
              <h2 class="subtitle">Handedness: {{PlayerData.player.handedness}}</h2>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <h2 class="subtitle">Age: {{PlayerData.player.age}}</h2>
            </div>
            <div class="column">
              <h2 class="subtitle">Nationality: {{PlayerData.player.birth_place}}</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="tabs is-fullwidth">
        <ul>
          <li v-bind:class="{'is-active': selected == 'overview',  'is-primary': selected != 'overview'}">    <a @click="selected = 'overview'; fetchPlayerStats()">Overview</a></li>
          <li v-bind:class="{'is-active': selected == 'game-logs',  'is-primary': selected != 'game-logs'}">  <a @click="selected ='game-logs'">Game Logs</a></li>
          <li v-bind:class="{'is-active': selected == 'power-play',  'is-primary': selected != 'power-play'}"><a @click="selected ='power-play'; fetchPlayerStats()">Power Play</a></li>
          <li v-bind:class="{'is-active': selected == 'points',  'is-primary': selected != 'points'}">        <a @click="selected ='points'; fetchPlayerStats()">Points</a></li>
          <li v-bind:class="{'is-active': selected == 'shots',  'is-primary': selected != 'shots'}">          <a @click="selected ='shots'; fetchPlayerStats()">Shooting</a></li>
          <li v-bind:class="{'is-active': selected == 'faceoffs',  'is-primary': selected != 'faceoffs'}">    <a @click="selected ='faceoffs'; fetchPlayerStats()">Faceoffs</a></li>
          <li v-bind:class="{'is-active': selected == 'turnovers',  'is-primary': selected != 'turnovers'}">  <a @click="selected ='turnovers'; fetchPlayerStats()">Turnovers</a></li>
          <li v-bind:class="{'is-active': selected == 'hits',  'is-primary': selected != 'hits'}">            <a @click="selected ='hits'; fetchPlayerStats()">Hits</a></li>
          <li v-bind:class="{'is-active': selected == 'toi',  'is-primary': selected != 'toi'}">              <a @click="selected ='toi'; fetchPlayerStats()">Time On Ice</a></li>
          <li v-bind:class="{'is-active': selected == 'pims',  'is-primary': selected != 'pims'}">            <a @click="selected ='pims'; fetchPlayerStats()">Penalty Minutes</a></li>
        </ul>
      </div>
      <div v-if="selected === 'overview'">
        <div class="columns is-centered">
          <div class="column is-offset-2">
            <h2 class="stat-title">Goals</h2>
            <h2 class="stat-title">Total Time On Ice</h2>
            <h2 class="stat-title">Shot Attempts</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.player_goals}}</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_total}}</h2>
            <h2 class="stat-number">{{PlayerData.player_shot_attempts}}</h2>
          </div>
          <div class="column">
            <h2 class="stat-title">Points</h2>
            <h2 class="stat-title">Shifts</h2>
            <h2 class="stat-title">Shots On Target</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.player_points}}</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_shifts}}</h2>
            <h2 class="stat-number">{{PlayerData.player_sot}}</h2>
          </div>
        </div>
      </div>
      <div v-if="selected === 'game-logs'">
        <div class="box">
            <apexchart type="line" height=350 :options="GameLogsCharOptions" :series="gameLogsChart" ref="game_logs_chart"></apexchart>
        </div>
        <sort-table endpoint="https://devilsapi.roblutken.com/api/app/player-stats/game-logs/"
          :postData="[{
          year: 2021,
          competition: 'EIHL',
          venue: 0,
          player_id: this.$route.params.player_id,
          team_id: 1
          }]"
          :selectedData="[{
                title: 'Date',
                prop:'game_date'
              }, 
              {
                title: 'G',
                prop: 'goals'
              }, 
              {
                title: 'PA',
                prop: 'first_assist'
              }, 
              {
                title: 'SA',
                prop: 'second_assist'
              }, 
              {
                title: 'PPTS',
                prop: 'primary_points'
              }, 
              {
                title: 'P',
                prop: 'points',
              }, 
              {
                title: 'PPG',
                prop: 'pp_goals'
              }, 
              {
                title: 'PPP',
                prop: 'pp_points'
              },
              {
                title: 'SHG',
                prop: 'sh_goals'
              },
              {
                title: 'SHP',
                prop: 'sh_points'
              },
              {
                title: 'SOG',
                prop: 'shots_on_net'
              },
              {
                title: 'SHOTS +',
                prop: 'shots_for'
              },
              {
                title: 'SHOTS -',
                prop: 'shots_against'
              },
              {
                title: 'SHOTS +/-',
                prop: 'shots_diff'
              },
              {
                title: 'TOI',
                prop: 'toi_total'
              },
              {
                title: 'Shifts',
                prop: 'toi_shifts'
              },
              {
                title: 'PIMT',
                prop: 'pim_taken'
              },
              {
                title: 'PIMD',
                prop:'pim_drawn'
              }
          ]" @dataLoaded="gameDataLoaded">
        </sort-table>
      </div>
      <div v-if="selected === 'points'">
        <div class="columns is-centered">
          <div class="column is-offset-2">
            <h2 class="stat-title">GP</h2>
            <h2 class="stat-title">Goals</h2>
            <h2 class="stat-title">Primary Assists</h2>
            <h2 class="stat-title">Secondary Assists</h2>
            <h2 class="stat-title">Assists</h2>
            <h2 class="stat-title">Points</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.gp_points}}</h2>
            <h2 class="stat-number">{{PlayerData.player_goals}}</h2>
            <h2 class="stat-number">{{PlayerData.player_first_assists}}</h2>
            <h2 class="stat-number">{{PlayerData.player_second_assists}}</h2>
            <h2 class="stat-number">{{PlayerData.player_assists}}</h2>
            <h2 class="stat-number">{{PlayerData.player_points}}</h2>
          </div>
          <div class="column">
            <h2 class="stat-title">Goals / 60</h2>
            <h2 class="stat-title">First Assists / 60</h2>
            <h2 class="stat-title">Second Assists / 60</h2>
            <h2 class="stat-title">Assists / 60</h2>
            <h2 class="stat-title">Points / 60</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.player_goals_60}}</h2>
            <h2 class="stat-number">{{PlayerData.player_first_assists_60}}</h2>
            <h2 class="stat-number">{{PlayerData.player_second_assists_60}}</h2>
            <h2 class="stat-number">{{PlayerData.player_assists_60}}</h2>
            <h2 class="stat-number">{{PlayerData.player_points_60}}</h2>
          </div>
        </div>
      </div>
      <div v-if="selected === 'power-play'">
        <div class="columns is-centered">
          <div class="column is-offset-2">
            <h2 class="stat-title">GP</h2>
            <h2 class="stat-title">Goals</h2>
            <h2 class="stat-title">PA</h2>
            <h2 class="stat-title">SA</h2>
            <h2 class="stat-title">Assists</h2>
            <h2 class="stat-title">Points</h2>
          </div>
          <div class="column is-2">
            <h2 class="stat-number">{{PlayerData.gp_shots}}</h2>
            <h2 class="stat-number">{{PlayerData.player_goals}}</h2>
            <h2 class="stat-number">{{PlayerData.player_first_assists}}</h2>
            <h2 class="stat-number">{{PlayerData.player_second_assists}}</h2>
            <h2 class="stat-number">{{PlayerData.player_assists}}</h2>
            <h2 class="stat-number">{{PlayerData.player_points}}</h2>
          </div>
          <div class="column is-2">
            <h2 class="stat-title">Shot Attempts</h2>
            <h2 class="stat-title">SOT</h2>
            <h2 class="stat-title">SH %</h2>
            <h2 class="stat-title">SOT %</h2>
            <h2 class="stat-title">TOI</h2>
            <h2 class="stat-title">Shifts</h2>
            <h2 class="stat-title">AVG Shift</h2>
            <h2 class="stat-title">AVG / G</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.player_shot_attempts}}</h2>
            <h2 class="stat-number">{{PlayerData.player_sot}}</h2>
            <h2 class="stat-number">{{PlayerData.player_shooting_percentage}}%</h2>
            <h2 class="stat-number">{{PlayerData.player_shot_percentage}}%</h2>
            <h2 class="stat-number">{{PlayerData.player_toi}}</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_shifts}}</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_shifts_avg}}</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_pp_per_game}}</h2>
          </div>
          <div class="column">
            <ShotsHeatmap></ShotsHeatmap>
          </div>
        </div>
      </div>
      <div v-if="selected === 'shots'">
        <div class="columns is-centered">
          <div class="column is-offset-2">
            <h2 class="stat-title">GP</h2>
            <h2 class="stat-title">Shot_attempts</h2>
            <h2 class="stat-title">% of Team Shots</h2>
            <h2 class="stat-title">SOT</h2>
            <h2 class="stat-title">SOT %</h2>
            <h2 class="stat-title">SH %</h2>
            <h2 class="stat-title">Shots For</h2>
            <h2 class="stat-title">Shots Against</h2>
            <h2 class="stat-title">Shots Diff</h2>
            <h2 class="stat-title">% of Team Goals</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.gp_shots}}</h2>
            <h2 class="stat-number">{{PlayerData.player_shot_attempts}}</h2>
            <h2 class="stat-number">{{PlayerData.player_shot_percentage}}</h2>
            <h2 class="stat-number">{{PlayerData.player_sot}}</h2>
            <h2 class="stat-number">{{PlayerData.player_sot_percentage}}</h2>
            <h2 class="stat-number">{{PlayerData.player_shooting_percentage}}</h2>
            <h2 class="stat-number">{{PlayerData.player_shots_for}}</h2>
            <h2 class="stat-number">{{PlayerData.player_shots_against}}</h2>
            <h2 class="stat-number">{{PlayerData.player_shots_diff}}</h2>
            <h2 class="stat-number">{{PlayerData.player_goals_percentage}}</h2>
          </div>
          <div class="column">
            <h2 class="stat-title">Shots / 60</h2>
            <h2 class="stat-title">SOT / 60</h2>
            <h2 class="stat-title">Shots For / 60</h2>
            <h2 class="stat-title">Shots Against / 60</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.player_shot_60}}</h2>
            <h2 class="stat-number">{{PlayerData.player_sot_60}}</h2>
            <h2 class="stat-number">{{PlayerData.player_shots_for_60}}</h2>
            <h2 class="stat-number">{{PlayerData.player_shots_against_60}}</h2>
          </div>
        </div>
      </div>
      <div v-if="selected === 'faceoffs'">
        <div class="columns is-centered">
          <div class="column is-offset-2">
            <h2 class="stat-title">GP</h2>
            <h2 class="stat-title">Taken</h2>
            <h2 class="stat-title">Won</h2>
            <h2 class="stat-title">Lost</h2>
            <h2 class="stat-title">Win %</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.gp_faceoffs}}</h2>
            <h2 class="stat-number">{{PlayerData.player_fo_taken}}</h2>
            <h2 class="stat-number">{{PlayerData.player_fo_win}}</h2>
            <h2 class="stat-number">{{PlayerData.player_fo_loss}}</h2>
            <h2 class="stat-number">{{PlayerData.player_fo_total_win_percentage}} %</h2>
          </div>
          <div class="column">
            <h2 class="stat-title">% Team FO Taken</h2>
            <h2 class="stat-title">% Team FO Win</h2>
            <h2 class="stat-title">% Team FO Lost</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.player_fo_t_percentage}} %</h2>
            <h2 class="stat-number">{{PlayerData.player_fo_win_percentage}} %</h2>
            <h2 class="stat-number">{{PlayerData.player_fo_loss_percentage}} %</h2>
          </div>
        </div>
      </div>

      <div v-if="selected === 'turnovers'">
        <div class="columns is-centered">
          <div class="column is-offset-2">
            <h2 class="stat-title">GP</h2>
            <h2 class="stat-title">Total</h2>
            <h2 class="stat-title">O-Zone</h2>
            <h2 class="stat-title">N-Zone</h2>
            <h2 class="stat-title">D-Zone</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.gp_turnovers}}</h2>
            <h2 class="stat-number">{{PlayerData.player_to_total}}</h2>
            <h2 class="stat-number">{{PlayerData.player_to_ozone}}</h2>
            <h2 class="stat-number">{{PlayerData.player_to_nzone}}</h2>
            <h2 class="stat-number">{{PlayerData.player_to_dzone}}</h2>
          </div>
          <div class="column">
            <h2 class="stat-title">% Team</h2>
            <h2 class="stat-title">% Team O-Zone</h2>
            <h2 class="stat-title">% Team N-Zone</h2>
            <h2 class="stat-title">% Team D-Zone</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.player_to_total_percentage}} %</h2>
            <h2 class="stat-number">{{PlayerData.player_to_ozone_percentage}} %</h2>
            <h2 class="stat-number">{{PlayerData.player_to_nzone_percentage}} %</h2>
            <h2 class="stat-number">{{PlayerData.player_to_dzone_percentage}} %</h2>
          </div>
        </div>
      </div>

      <div v-if="selected === 'hits'">
        <div class="columns is-centered">
          <div class="column is-offset-2">
            <h2 class="stat-title">GP</h2>
            <h2 class="stat-title">Hits</h2>
            <h2 class="stat-title">Hits Per Game</h2>
            <h2 class="stat-title">Hits Per 60</h2>
            <h2 class="stat-title"> % of Team Hits</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.gp_hits}}</h2>
            <h2 class="stat-number">{{PlayerData.player_hits}}</h2>
            <h2 class="stat-number">{{PlayerData.player_hits_per_game}}</h2>
            <h2 class="stat-number">{{PlayerData.player_hits_sixty}}</h2>
            <h2 class="stat-number">{{PlayerData.player_hits_vs_team}}%</h2>
          </div>
          <div class="column">
            <h2 class="stat-title">EH</h2>
            <h2 class="stat-title">SH</h2>
            <h2 class="stat-title">PP</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.player_hits_eh}}</h2>
            <h2 class="stat-number">{{PlayerData.player_hits_pp}}</h2>
            <h2 class="stat-number">{{PlayerData.player_hits_sh}}</h2>
          </div>
        </div>
      </div>
      <div v-if="selected === 'toi'">
        <div class="columns is-centered">
          <div class="column is-offset-2">
            <h2 class="stat-title">GP</h2>
            <h2 class="stat-title">Total TOI</h2>
            <h2 class="stat-title">AVG TOI</h2>
            <h2 class="stat-title">AVG Shift</h2>
            <h2 class="stat-title">Shifts</h2>
            <h2 class="stat-title">AVG Shift / G</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.gp_toi}}</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_total}}</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_per_game}}</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_avg_shift}}</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_shifts}}</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_shifts_avg}}</h2>
          </div>
        </div>
        <div class="columns is-centered">
          <div class="column is-offset-2">
            <h2 class="stat-title">EH TOI</h2>
            <h2 class="stat-title">PP TOI</h2>
            <h2 class="stat-title">SH TOI</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.player_toi_eh}}</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_pp}}</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_sh}}</h2>
          </div>
          <div class="column is-3">
            <h2 class="stat-title">EH AVG</h2>
            <h2 class="stat-title">PP AVG</h2>
            <h2 class="stat-title">SH AVG</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.player_toi_eh_per_game}}</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_pp_per_game}}</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_sh_per_game}}</h2>
          </div>
        </div>
        <div class="columns is-centered">
          <div class="column is-offset-2">
            <h2 class="stat-title">EH Shifts</h2>
            <h2 class="stat-title">PP Shifts</h2>
            <h2 class="stat-title">SH Shifts</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.player_toi_eh_shifts}}</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_pp_shifts}}</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_sh_shifts}}</h2>
          </div>
          <div class="column is-3">
            <h2 class="stat-title">EH Shifts AVG</h2>
            <h2 class="stat-title">PP Shifts AVG</h2>
            <h2 class="stat-title">SH Shifts AVG</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.player_toi_eh_shifts_gp}}</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_pp_shifts_gp}}</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_sh_shifts_gp}}</h2>
          </div>
        </div>
        <h2 class="stat-category has-text-centered">Team %</h2>
        <div class="columns is-centered">
          <div class="column is-offset-2">
            <h2 class="stat-title">Total Time</h2>
            <h2 class="stat-title">EH Time</h2>
            <h2 class="stat-title">PP Time</h2>
            <h2 class="stat-title">SH Time</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.player_toi_team}}%</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_team_eh}}%</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_team_pp}}%</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_team_sh}}%</h2>
          </div>
          <div class="column is-3">
            <h2 class="stat-title">Shifts</h2>
            <h2 class="stat-title">EH Shifts</h2>
            <h2 class="stat-title">PP Shifts</h2>
            <h2 class="stat-title">SH Shifts</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.player_toi_team_shifts}}%</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_team_shifts_eh}}%</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_team_shifts_pp}}%</h2>
            <h2 class="stat-number">{{PlayerData.player_toi_team_shifts_sh}}%</h2>
          </div>
        </div>
      </div>
      <div v-if="selected === 'pims'">
        <div class="columns is-centered">
          <div class="column is-offset-2 is-3">
            <h2 class="stat-title">GP</h2>
            <h2 class="stat-title">No. Taken</h2>
            <h2 class="stat-title">No. Drawn</h2>
            <h2 class="stat-title">Mins Taken</h2>
            <h2 class="stat-title">Mins Drawn</h2>
            <h2 class="stat-title">Mins Taken Minor</h2>
            <h2 class="stat-title">Mins Drawn Minor</h2>
            <h2 class="stat-title">Mins Taken Major</h2>
            <h2 class="stat-title">Mins Drawn Major</h2>
            <h2 class="stat-title">Mins Taken Misconduct</h2>
            <h2 class="stat-title">Mins Drawn Misconduct</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.gp_pims}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_taken_count}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_drawn_count}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_taken_minutes}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_drawn_minutes}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_taken_minutes_minor}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_drawn_minutes_minor}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_taken_minutes_major}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_drawn_minutes_major}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_taken_minutes_misconduct}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_drawn_minutes_misconduct}}</h2>
          </div>
          <div class="column is-4">
            <h2 class="stat-title">Mins Taken / Game</h2>
            <h2 class="stat-title">Mins Drawn / Game</h2>
            <h2 class="stat-title">Mins Taken Minor / Game</h2>
            <h2 class="stat-title">Mins Drawn Minor / Game</h2>
            <h2 class="stat-title">Mins Taken Major / Game</h2>
            <h2 class="stat-title">Mins Drawn Major / Game</h2>
            <h2 class="stat-title">Mins Taken Misconduct / Game</h2>
            <h2 class="stat-title">Mins Drawn Misconduct / Game</h2>
            <h2 class="stat-title">Mins Taken / 60</h2>
            <h2 class="stat-title">Mins Drawn / 60</h2>
          </div>
          <div class="column">
            <h2 class="stat-number">{{PlayerData.player_pens_taken_per_game}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_drawn_per_game}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_taken_per_game_minor}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_drawn_per_game_minor}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_taken_per_game_major}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_drawn_per_game_major}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_taken_per_game_misconduct}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_drawn_per_game_misconduct}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_taken_per_sixty}}</h2>
            <h2 class="stat-number">{{PlayerData.player_pens_drawn_per_sixty}}</h2>
          </div>
        </div>
        <div class="box">

          <div class="columns is-centered">
            <div class="column is-offset-2 is-3">
              <h2 class="stat-title">% of Team Taken</h2>
              <h2 class="stat-title">% of Team Drawn</h2>
              <h2 class="stat-title">% of Team Taken Minor</h2>
              <h2 class="stat-title">% of Team Drawn Minor</h2>
              <h2 class="stat-title">% of Team Taken Major</h2>
              <h2 class="stat-title">% of Team Drawn Major</h2>
              <h2 class="stat-title">% of Team Taken Misconduct</h2>
              <h2 class="stat-title">% of Team Drawn Misconduct</h2>
            </div>
            <div class="column">
              <h2 class="stat-number">{{PlayerData.player_pens_taken_team_percentage}}%</h2>
              <h2 class="stat-number">{{PlayerData.player_pens_drawn_team_percentage}}%</h2>
              <h2 class="stat-number">{{PlayerData.player_pens_taken_team_percentage_minor}}%</h2>
              <h2 class="stat-number">{{PlayerData.player_pens_drawn_team_percentage_minor}}%</h2>
              <h2 class="stat-number">{{PlayerData.player_pens_taken_team_percentage_major}}%</h2>
              <h2 class="stat-number">{{PlayerData.player_pens_drawn_team_percentage_major}}%</h2>
              <h2 class="stat-number">{{PlayerData.player_pens_taken_team_percentage_misconduct}}%</h2>
              <h2 class="stat-number">{{PlayerData.player_pens_drawn_team_percentage_misconduct}}%</h2>
            </div>
            <div class="column is-4">
              <h2 class="stat-category has-text-centered">Major & Minor Only</h2>
              <h2 class="stat-title">Mins O-Zone Taken</h2>
              <h2 class="stat-title">Mins O-Zone Drawn</h2>
              <h2 class="stat-title">Mins N-Zone Taken</h2>
              <h2 class="stat-title">Mins N-Zone Drawn</h2>
              <h2 class="stat-title">Mins D-Zone Taken</h2>
              <h2 class="stat-title">Mins D-Zone Drawn</h2>
            </div>
            <div class="column">
              <h2 class="stat-number">-</h2>
              <h2 class="stat-number">{{PlayerData.player_pens_taken_minutes_ozone}}</h2>
              <h2 class="stat-number">{{PlayerData.player_pens_drawn_minutes_ozone}}</h2>
              <h2 class="stat-number">{{PlayerData.player_pens_taken_minutes_nzone}}</h2>
              <h2 class="stat-number">{{PlayerData.player_pens_drawn_minutes_nzone}}</h2>
              <h2 class="stat-number">{{PlayerData.player_pens_taken_minutes_dzone}}</h2>
              <h2 class="stat-number">{{PlayerData.player_pens_drawn_minutes_dzone}}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import SortTable from '../sort-table.vue'
import VueApexCharts from 'vue-apexcharts'
import ShotsHeatmap from '../shots-heatmap-single.vue'
export default {
  props: ['pID'],
  components: {
    SortTable,
    apexcharts: VueApexCharts,
    'ShotsHeatmap': ShotsHeatmap
  },
  data: function () {
    return {
      selected: 'overview',
      PlayerData: [],
      GameLogs: [],
      GameLogsChartData: [],
      GameLogsCharOptions: {
        chart: {
          title: {
            text: 'Points / Season',
            align: 'left',
            enabled: true
          },
          toolbar: { show: false },
          height: 350,
          zoom: {
            enabled: false
          },
          stroke: {
            curve: 'smooth',
            lineCap: 'butt'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        colors: ['#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800', '#D68910', '#34495E', '#78281F', '#27AE60', '#76448A'],
        title: {
          text: 'Game By Game',
          align: 'left'
        },
        markers: {
          size: 3,
          shape: 'circle',
          radius: 3,
          hover: {
            sizeOffset: 2
          }
        },
        xaxis: {
          type: 'category',
          categories: []
        },
        plotOptions: {
        }
      }
    }
  },
  computed: {
    gameLogsChart () {
      this.GameLogsChartData = [{name: 'Points', data: []}]
      this.GameLogsChartData.push({name: 'Primary Assists', data: []})
      this.GameLogsChartData.push({name: 'Secondary Assists', data: []})
      this.GameLogsChartData.push({name: 'Goals', data: []})
      this.GameLogsChartData.push({name: 'Toi', data: []})
      this.GameLogsChartData.push({name: 'Shifts', data: []})
      this.GameLogsChartData.push({name: 'Shots On Net', data: []})
      this.GameLogsChartData.push({name: 'Shots +', data: []})
      this.GameLogsChartData.push({name: 'Shots -', data: []})
      this.GameLogsChartData.push({name: 'PIM Taken', data: []})
      this.GameLogsChartData.push({name: 'PIM Drawn', data: []})
      let cats = []
      // this.lastFiveSeries.push({name: 'Diff', data: []})
      for (var stat of this.GameLogs) {
        // this.lastFiveOptions.labels.push(stat.match_date)
        cats.push(stat.game_date + ' ' + stat.opponent)
        this.GameLogsChartData[0].data.push(stat.points)
        this.GameLogsChartData[1].data.push(stat.first_assist)
        this.GameLogsChartData[2].data.push(stat.second_assist)
        this.GameLogsChartData[3].data.push(stat.goals)
        this.GameLogsChartData[4].data.push(stat.toi_total_mins)
        this.GameLogsChartData[5].data.push(stat.toi_shifts)
        this.GameLogsChartData[6].data.push(stat.shots_on_net)
        this.GameLogsChartData[7].data.push(stat.shots_for)
        this.GameLogsChartData[8].data.push(stat.shots_against)
        this.GameLogsChartData[9].data.push(stat.pim_taken)
        this.GameLogsChartData[10].data.push(stat.pim_drawn)
      }
      this.GameLogsCharOptions = {
        ...this.GameLogsCharOptions,
        ...{
          xaxis: {
            categories: cats
          }
        }
      }
      return this.GameLogsChartData
    }
  },
  methods: {
    gameDataLoaded (data) {
      this.GameLogs = data
    },
    fetchPlayerStats () {
      let postData = {
        'year': 2022,
        'competition': 'EIHL_Challenge_Cup',
        'venue': 0,
        'opponent': 0,
        'limit': 0,
        'player_id': this.$route.params.player_id,
        'team_id': 1,
        'stat': this.selected
      }
      console.log(this.$route.params.player_id)
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/player-stats/report-card/', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log(response.data)
            this.PlayerData = response.data
          },
          response => {}
        )
    }
  },
  created: function () {
    console.log('created')
  },
  beforeCreate: function () {
    console.log('before create')
  },
  beforeMount: function () {
    console.log('BM FETCH')
    this.fetchPlayerStats()
  },
  mounted: function () {
    console.log('FETCHING......')
    this.fetchPlayerStats()
  }
}
</script>
<style lang='scss' scoped>
.segment {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 98%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.segment h1 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 3em;
}
.segment p{
  font-size:1.2em;
  text-transform: uppercase;
}
.stat-title{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.3rem;
  margin: 1rem 0rem;
}
.stat-category{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.5rem;
  margin: 1rem 0rem;
}
.stat-number{
  font-family: 'Heebo', sans-serif;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.3rem;
  margin: 1rem 0rem;
  color:black;
}
</style>



// WEBPACK FOOTER //
// player-report.vue?1bc2228c